<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>


<div class="container px-4 py-7">
  <div class="w-full form-container">
    <div class="w-full p-6 bg-white rounded-md shadow-lg">
      <h2 class="mb-4 text-2xl font-bold">Edit Subscription</h2>
        <div class="mb-4 form-group">
          <label for="first_name" class="block text-sm font-medium text-gray-700"
            >Customer:</label>
            <p-autocomplete id='customer' [(ngModel)]="selectedCustomer" optionLabel="name" [suggestions]="filteredCustomers" (completeMethod)="searchCustomers($event)" />
        </div>
        <div class="mb-4 form-group">
          <label for="plan" class="block text-sm font-medium text-gray-700"
            >Service Plan:</label
          >
          <p-autocomplete id="plan" [(ngModel)]="selectedPlan" optionLabel="name" [suggestions]="filteredServicePlans" (completeMethod)="searchServicePlans($event)" />
        </div>
        <div class="mb-4 form-group">
          <label for="plan" class="block text-sm font-medium text-gray-700"
            >Activation Date:</label
          >
          <p-datepicker [(ngModel)]="activationDate" />
        </div>
        <div class="mb-4 form-group">
          <label for="plan" class="block text-sm font-medium text-gray-700"
            >Next Due:</label
          >
          <p-datepicker [(ngModel)]="nextDue" />
        </div>

        <div class="flex justify-start py-4">
          <button
            pButton
            (click)="onSubmit()"
            class="rounded-md primary-btn"
          >
          Update
        </button>
        </div>
    </div>
  </div>
</div>
